import { createContext, useContext } from 'react';

export type AuthStatus = 'loading' | 'unauthenticated' | 'authenticated';

export interface AuthAccount {
  email: string;
  name: string;
}

export interface AuthState {
  status: AuthStatus;
  account: AuthAccount | null;
  signIn: () => Promise<void> | void;
  signOut: () => Promise<void> | void;
  /** Resolves the bearer token (Entra ID token, aud=clientId) for API calls. */
  getToken: () => Promise<string | null>;
}

const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside an <AuthProvider> or test wrapper');
  }
  return ctx;
}

export const AuthContextProvider = AuthContext.Provider;
